// extracted by mini-css-extract-plugin
export var container = "_bv-0";
export var icon = "_bv-1";
export var text = "_bv-2";